/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Faq_3_QInputs */

const en_cp_faq_3_q = /** @type {(inputs: Cp_Faq_3_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do students have to use a specific AI coding agent?`)
};

const id_cp_faq_3_q = /** @type {(inputs: Cp_Faq_3_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apakah mahasiswa harus memakai AI coding agent tertentu?`)
};

/**
* | output |
* | --- |
* | "Do students have to use a specific AI coding agent?" |
*
* @param {Cp_Faq_3_QInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_faq_3_q = /** @type {((inputs?: Cp_Faq_3_QInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Faq_3_QInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_faq_3_q(inputs)
	return en_cp_faq_3_q(inputs)
});